<app-bread-crumb [items]="[{text:'parceiros'}]" [sectionTitle]="'Lista de Parceiros'"></app-bread-crumb>

<section class="content">

  <div class="row">

    <div class="col-md-12">


      <ng-box [boxIcon]="'fa fa-briefcase'" [boxTitle]="'Parceiros'">
        <!-- cabesalho do box -->
        <ng-container class="ng-box-header">

          <ng-button 
            *ngIf="isAdmin()" 
            (click)="create()"
            [button]="{name:'novo parceiro', faIconClass:'fa fa-plus',color:'danger'}">
          </ng-button>

        </ng-container>

        <!-- conteúdo do box -->
        <ng-container class="ng-box-content">

          <!-- tabela -->
          <ng-table [tableHeaderAndFooterColumns]="tableProprieties()" *ngIf="!isSpinnerLoading">

            <tr *ngFor="let partiner of objects;index" ngChangeColorOnHover>

              <td>
                <strong style="font-size: large; color:#f35309">{{partiner?.name}}</strong> <br>
                <small>{{partiner?.partner_description}}</small>
              </td>

              <td>
                {{partiner?.city?.name}}
              </td>

              <td>
                {{partiner?.address}}
              </td>

              <td>
                {{partiner?.phone}}
              </td>
              <td>
                {{partiner?.created_at | date:'dd/MM/yyyy HH:mm:ss'}}
              </td>

            <ng-actions-table-bar *ngIf="isAdmin()">
              <ng-button
                title="Editar"
                (click)="edit(partiner)"
                [button]="{faIconClass:'fa fa-edit',color:'danger'}"
              ></ng-button>
              <ng-button
                title="Detalhe"
                (click)="detail(partiner)"
                [button]="{faIconClass:'fa fa-eye',color:'danger'}"
              ></ng-button>
              <ng-button
                title="Excluir"
                (click)="delete(partiner)"
                [button]="{faIconClass:'fa fa-close',color:'danger'}"
              ></ng-button>
            </ng-actions-table-bar>

            </tr>

          </ng-table>

          <!-- fim da tabela -->
          <ng-box-table-spinner class="overlay" *ngIf="isSpinnerLoading"></ng-box-table-spinner>

        </ng-container>
        <!-- fim do contedo do box -->

      </ng-box>

      <!-- fim do box -->

    </div>

  </div>
</section>